import React from 'react';

export const useDropdown = ({ options, selectedOptionId }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const containerRef = React.useRef(null);

  const isClickInsideDropdown = (e) =>
    containerRef.current && containerRef.current.contains(e.target);

  const outsideClickHandler = (e) => {
    if (isClickInsideDropdown(e)) {
      return;
    }
    setIsOpen(false);
  };

  React.useEffect(() => {
    window.addEventListener('mousedown', outsideClickHandler);
    return () => window.removeEventListener('mousedown', outsideClickHandler);
  }, []);

  const activeOption = options.find((_) => _.id === selectedOptionId) || {
    value: '',
  };

  return { isOpen, setIsOpen, containerRef, activeOption };
};
